import classNames from 'classnames';
import { Picture, View, Icon } from 'components';
import styles from './PictureItem.module.scss';

/**
 * PictureItem
 *
 * @return {JSX.Element}
 */
const PictureItem = ({ className, disabled, onRemove, src }) => {
  return (
    <View
      className={classNames(
        styles.PictureItem,
        disabled && styles.PictureItem__disabled,
        className,
        `${PictureItem.displayName}`
      )}
    >
      {!disabled ? (
        <Icon
          name="close"
          highlight="black"
          className={styles.RemovePictureIcon}
          onClick={onRemove}
        />
      ) : null}
      <Picture src={src} alt="" />
    </View>
  );
};

PictureItem.displayName = 'PictureItem';

export default PictureItem;
